var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirplanePlaneBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66535 6.33333L4.75516 2.998C4.63699 2.79168 4.63765 2.53804 4.75689 2.33233C4.87613 2.12663 5.0959 2 5.33367 2H6.07558C6.25292 2 6.42296 2.07066 6.54807 2.19635L10.666 6.33333",
    stroke: "#5A5A5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05324 9.33331L4.07991 13.0186C3.96929 13.2253 3.97529 13.4748 4.09571 13.6759C4.21613 13.8769 4.43328 14 4.66765 14H5.44153C5.61967 14 5.79039 13.9287 5.91562 13.802L10.3334 9.33331",
    stroke: "#5A5A5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99982 9.33331H3.03639C2.4625 9.33332 1.95299 8.96609 1.77151 8.42165L0.701209 5.2108C0.633442 5.0075 0.667534 4.78402 0.792835 4.61017C0.918135 4.43633 1.11937 4.33331 1.33366 4.33331H2.28997C2.65124 4.33331 2.98442 4.52818 3.16154 4.84305L3.99982 6.33331H13.8331C14.6616 6.33331 15.3331 7.00489 15.3331 7.83331V7.83331C15.3331 8.66174 14.6616 9.33331 13.8331 9.33331H10.3331",
    stroke: "#5A5A5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplanePlaneBig);
export default __webpack_public_path__ + "static/media/airplane-plane-big.0b396509a2b5b1b0bb870e0755bb435e.svg";
export { ForwardRef as ReactComponent };